import styled from 'styled-components';

import {
  SkeletonFormField as SkeletonFormFieldComponent,
  SkeletonHeadline as SkeletonHeadlineComponent,
  SkeletonBodyCopy as SkeletonBodyCopyComponent,
} from '@xing-com/skeleton';
import { scale240, spaceM, spaceXL, spaceXXL } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const SkeletonHeadline = styled(SkeletonHeadlineComponent)`
  margin-bottom: ${spaceXXL};
`;

export const SkeletonBodyCopy = styled(SkeletonBodyCopyComponent)`
  margin-bottom: ${spaceM};
`;

export const SkeletonFormField = styled(SkeletonFormFieldComponent)`
  height: ${scale240};
`;

export const AboutEditBodyCopy = styled(BodyCopy)`
  margin: ${spaceXL} 0 ${spaceM};
`;
